const checklistItems = [
  "Aadhaar Card",
  "PAN Card",
  "Passport",
  "Driving License",
  "Voter ID",
  "GST Certificate",
  "Company Registration Certificate",
  "Incorporation Certificate",
  "Authorization Letter",
  "Affidavit",
  "Agreement Copy",
  "Memorandum of Association (MOA)",
  "Articles of Association (AOA)",
  "Board Resolution",
  "Address Proof",
  "Bank Statement",
  "Cancelled Cheque",
  "Logo",
  "Photograph",
  "Digital Signature Certificate",
  "Other Supporting Document",
  "Other"
];
export default checklistItems;